module.exports = __webpack_public_path__ + "d5700d9f68fc8828308456905dc06084.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-86.cur
// module id = 482
// module chunks = 0